// @flow

import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'seedling/constants';
import Button from 'seedling/components/button';
import useModal from './use_modal';
import Typography from '../typography';
import FormSubmitButtons from 'seedling/components/form_submit_buttons';

import { Container, Header, Content, Footer, Modal } from './modal';

type WarningModalProps = {
  title: string,
  onConfirm: Function,
  dangerText: string,
  children: React.Element<any>,
  warningText?: string,
  modalContent?: React.Element<any>,
  fullWidth?: boolean,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  submitText?: string,
  disableSubmitButton: boolean,
};

const WarningModal = (props: WarningModalProps) => {
  const {
    children,
    warningText,
    onConfirm,
    modalContent,
    submitText,
    dangerText,
    disableSubmitButton,
    title,
    ...restProps
  } = props;

  const [open, openModal, closeModal] = useModal(false);

  function confirm() {
    onConfirm();
    closeModal();
  }

  return (
    <React.Fragment>
      {React.cloneElement(children, {
        onClick: openModal,
      })}
      <Modal>
        <Container
          {...restProps}
          open={open}
          closeModal={closeModal}
          draggable={false}
          data-provides="warning-modal"
        >
          <RedHeader
            title={title}
            closeModal={closeModal}
            displayXIcon={false}
            draggable={false}
          />
          <Content>
            {warningText ? (
              <Typography type="p">{warningText}</Typography>
            ) : (
              modalContent
            )}
          </Content>
          <Footer>
            <FormSubmitButtons
              onSubmit={closeModal}
              onCancel={confirm}
              submitText={
                submitText || FormSubmitButtons.defaultProps.submitText
              }
              compact={true}
              cancelComponent={
                <Button danger disabled={disableSubmitButton}>
                  {dangerText}
                </Button>
              }
            />
          </Footer>
        </Container>
      </Modal>
    </React.Fragment>
  );
};

export default WarningModal;

WarningModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: true,
  maxWidth: 'sm',
  disableSubmitButton: false,
};

const RedHeader = styled(Header)`
  background-color: ${colors.darkRed};

  #modal_title {
    color: ${colors.white};
  }
`;
